import { render, staticRenderFns } from "./toBuy.vue?vue&type=template&id=18ed4b42&scoped=true&"
import script from "./toBuy.vue?vue&type=script&lang=js&"
export * from "./toBuy.vue?vue&type=script&lang=js&"
import style0 from "./toBuy.vue?vue&type=style&index=0&id=18ed4b42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ed4b42",
  null
  
)

export default component.exports